import { useEffect, useState } from "react";
import { getNewsInner } from "../Service/Api";
import { Link } from 'react-router-dom';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Breadcrumb from '../Component/Breadcrumb';

const News = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setSelectedYear(`${currentYear}`);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const galleryData = await getNewsInner();
      setData(galleryData);

      const yearsSet = new Set();
      const monthsSet = new Set();

      galleryData.forEach(item => {
        if (item.fromDate) {
          const date = new Date(item.fromDate);
          yearsSet.add(date.getFullYear());
          monthsSet.add(date.getMonth()); // Months are zero-based
        }
      });

      const uniqueYearRanges = Array.from(yearsSet).sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);

      const uniqueMonths = Array.from(monthsSet).sort((a, b) => a - b);
      const monthNamesOptions = uniqueMonths.map(month => monthNames[month]);
      setMonthOptions(["All", ...monthNamesOptions]);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const filterDataByYearAndMonth = (year, month) => {
      return data.filter(item => {
        if (item.fromDate) {
          const date = new Date(item.fromDate);
          const itemYear = date.getFullYear();
          const itemMonth = date.getMonth(); // Months are zero-based
          return (
            itemYear === year &&
            (month === "All" || monthNames[itemMonth] === month)
          );
        }
        return false;
      });
    };

    const filterAndSetData = () => {
      const currentYear = parseInt(selectedYear);
      let filteredData = filterDataByYearAndMonth(currentYear, selectedMonth);

      if (filteredData.length === 0 && selectedYear !== "All") {
        const previousYear = yearRanges.find(year => year < currentYear);
        if (previousYear) {
          filteredData = filterDataByYearAndMonth(previousYear, selectedMonth);
          if (filteredData.length > 0) {
            setSelectedYear(previousYear.toString());
          }
        }
      }

      if (searchQuery) {
        filteredData = filteredData.filter(item =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      setFilteredData(filteredData);
    };

    filterAndSetData();
  }, [selectedYear, selectedMonth, searchQuery, data, yearRanges]);

  return (
    <>
      <Header />
      <Breadcrumb title="Latest News" pageName="Latest News" mid="News" />
      <div className="innerSection">
        <div className="container">
          <div className="row">
            <div className='col-md-12'>
              <h3 className='inner_title'>Latest News</h3>
            </div>
          </div>
          <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                <p>Total Count: {filterData.length}</p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select  
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection">
                  <option value={"All"}>All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>{yr}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="monthSelect"> 
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>{month}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>
          <div className="row years year2023 showYear">
            {filterData.length > 0 ? (
              filterData.map((item, index) => (
                <div className="col-md-12 newsCount" key={index}>
                  <div className="inr-news-blk">
                    <h6 className="date">{item.date}</h6>
                    <div className="inr-news-content">
                      <h3 className="sub_title">{item.title}</h3>
                      <p>{item.description}</p>
                      <h6 className="loc">
                        {item.attachments && item.attachments.length > 0 && (
                          <Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank">
                            <span> View Attachment <i className="bi bi-arrow-right"></i> </span>
                          </Link>
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12">
                <div className="inr-news-blk">
                  <h6 className="date">DD.MM.YYYY</h6>
                  <div className="inr-news-content">
                    <h3 className="sub_title">News Title</h3>
                    <p>Stay Tuned for more Updates</p>
                    <h6 className="loc">
                      <Link to="#" target="_blank">
                        <span> View Attachment <i className="bi bi-arrow-right"></i> </span>
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default News;
